import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SingleBedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"single_bed"}/>
}
